//import React, { useState, useEffect } from "react";
import * as Highcharts from "highcharts";
import React, { Component, PureComponent } from "react";

import HighchartsReact from "highcharts-react-official";
import { getSentimentColor, getStrokeColor, numberWithCommas, kmFormatter } from "../utils";
import { chartColors } from "../../../../../lib/utils";

class PieChart extends PureComponent {
    state = {};

    chartComponent = React.createRef();

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    getPlatformName = (id) => {
        return this.props.allPlatforms && this.props.allPlatforms.find((plt) => plt.id === id).short_name;
    };

    getPlatformShortName = (id) => {
        return this.props.allPlatforms && this.props.allPlatforms.find((plt) => plt.id === id).name;
    };

    getOptions = () => {
        let data = this.props.dataProp[this.props.splineType];
        let totData = 0;

        let cols = [];

        for (let pltId in data) {
            if (data[pltId] !== 0) {
                totData += Math.floor(data[pltId]);
                let nameAt = this.getPlatformName(pltId);
                let gendername = nameAt.split("");
                let initLetter = gendername[0].toUpperCase();
                let actualName = gendername.slice(1, gendername.length);

                actualName.unshift(initLetter);
                actualName = actualName.join("");
                cols.push({ name: actualName, y: Math.floor(data[pltId]), shortName: this.getPlatformName(pltId) });
            }
        }

        cols.forEach((element, i) => {
            let color = getStrokeColor(element.shortName);
            element.color = color;
            element.percentVal = ((element.y / totData) * 100).toFixed(1);
        });

        cols = cols && cols.sort((a, b) => b.percentVal - a.percentVal);

        const options = {
            chart: {
                type: "pie",
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            title: {
                text: " ",
            },
            credits: {
                enabled: false,
            },
            legend: {
                enabled: this.props.showLegendBar,
                itemStyle: {
                    fontWeight: 400,
                },
                alignColumns: false,
                margin: 0,
                align: "center",
            },
            plotOptions: {
                pie: {
                    shadow: false,
                    center: ["50%", "50%"],
                    //colors: pieColors,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: this.props.showLabel,
                        distance: "10%",
                        style: {
                            fontWeight: 400,
                            textOutline: "none",
                        },
                        formatter: function () {
                            return `<span>${this.point.name}: </span> <span>${this.point.percentVal}%</span>
                            `;
                        },
                    },
                    showInLegend: true,
                },
            },
            series: [
                {
                    data: cols,
                },
            ],
            tooltip: {
                followPointer: true,
                followTouchMove: true,
                outside: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                },
                formatter: function () {
                    return `<p>${this.key}:</p> <p><b>${this.point.percentVal}%</b> | <b>${numberWithCommas(this.y)}</b>/ 
                    <b>${numberWithCommas(totData)}</b></p>`;
                },
            },
        };

        return options;
    };

    render() {
        return (
            <HighchartsReact
                ref={this.chartComponent}
                highcharts={Highcharts}
                options={this.getOptions()}
                containerProps={{ style: { width: "100%", height: "100%" } }}
            />
        );
    }
}

export default PieChart;
